<template>
  <div class="me-njofto-settings-wrapper">
    <div class="checkbox-weekday">
      <v-checkbox
        class="njoftime-checkbox"
        color="primary"
        v-model="notify_anytime"
        :label="getStateWithParam('anytime')"
      ></v-checkbox>
      <v-select
        :key="select_days_key"
        chips
        v-model="selected_day"
        :items="getDays()"
        :label="getStateWithParam('week_days')"
        multiple
        @change="getDaySelected()"
      >
        <template v-slot:prepend-item>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon :color="selected_day.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
            </v-list-tile-action>
            <div class="select-all">
              <div
                v-show="show_select_all"
                ripple
                @click="toggle"
              >{{getStateWithParam('selectall')}}</div>
              <div>
                <v-btn @click="dissmisDayOfWeek" flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </div>
          </v-list-tile>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-select>
      <StartEndDatePicker
        v-on:getTime="getStartTime"
        :name="getStateWithParam('start')"
        :time_incoming="digest.start"
        :menu="false"
      />
      <StartEndDatePicker
        v-on:getTime="getEndTime"
        :time_incoming="digest.finish"
        :name="getStateWithParam('finish')"
        :menu="false"
      />
    </div>
  </div>
</template>

<script>
import StartEndDatePicker from "./StartEndDatePicker";
export default {
  name: "NjoftimeSettingsComponent",
  components: {
    StartEndDatePicker
  },
  props: {
    digest: {
      type: [Object]
    }
  },
  data() {
    return {
      show_select_all: true,
      notify_anytime: this.digest.anytime,
      selected_day: this.digest.weekdays,
      select_days_key: 9000,
      arr_of_days_to_send: [false, false, false, false, false, false, false]
    };
  },
  watch: {
    notify_anytime: function() {
      this.$emit("notifyAnytimeEvent", this.notify_anytime);
    }
  },
  computed: {
    icon() {
      if (this.select_all_days) return "mdi-close-box";
      if (this.delect_some_days) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  mounted() {
    this.refreshDaySelector();
    this.fillWeekdayWithSelectedDays();
  },
  methods: {
    dissmisDayOfWeek() {
      this.select_days_key += 1;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.select_all_days) {
          this.selected_day = [];
        } else {
          this.selected_day = this.getDays().slice();
        }
      });
      this.getDaySelected(1);
    },
    getStartTime(param) {
      this.$emit("startTime", param);
    },
    getEndTime(param) {
      this.$emit("endTime", param);
    },
    getStateWithParam(param) {
      return this.$store.getters.getLanguageParameters(param);
    },
    refreshDaySelector() {
      this.select_days_key = this.select_days_key + 1;
    },
    getDaySelected(all = 0) {
      if (all) {
        this.$emit("selected_days", "all");
      } else {
        this.prepareArrayToSend();
      }
    },
    prepareArrayToSend() {
      this.filterDayWithIndex("monday", 0);
      this.filterDayWithIndex("tuesday", 1);
      this.filterDayWithIndex("wednesday", 2);
      this.filterDayWithIndex("thursday", 3);
      this.filterDayWithIndex("friday", 4);
      this.filterDayWithIndex("saturday", 5);
      this.filterDayWithIndex("sunday", 6);
      this.$emit("selected_days", this.arr_of_days_to_send);
    },
    filterDayWithIndex(day, index_day_array) {
      if (
        this.selected_day.filter(
          word => word == this.getStateWithParam(day)
        )[0] != undefined
      ) {
        this.arr_of_days_to_send[index_day_array] = 1;
      } else {
        this.arr_of_days_to_send[index_day_array] = 0;
      }
    },
    fillWeekdayWithSelectedDays() {
      this.digest.weekdays.forEach((el, index) => {
        if (el) {
          switch (index + 1) {
            case 1:
              this.selected_day.push(this.getStateWithParam("monday"));
              break;
            case 2:
              this.selected_day.push(this.getStateWithParam("tuesday"));
              break;
            case 3:
              this.selected_day.push(this.getStateWithParam("wednesday"));
              break;
            case 4:
              this.selected_day.push(this.getStateWithParam("thursday"));
              break;
            case 5:
              this.selected_day.push(this.getStateWithParam("friday"));
              break;
            case 6:
              this.selected_day.push(this.getStateWithParam("saturday"));
              break;
            case 7:
              this.selected_day.push(this.getStateWithParam("sunday"));
              break;
          }
        }
      });
    },
    getDays() {
      return [
        this.getStateWithParam("monday"),
        this.getStateWithParam("tuesday"),
        this.getStateWithParam("wednesday"),
        this.getStateWithParam("thursday"),
        this.getStateWithParam("friday"),
        this.getStateWithParam("saturday"),
        this.getStateWithParam("sunday")
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.me-njofto-settings-wrapper {
  padding: 16px;
  padding-top: 0px;
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-bottom: 5px;
    &:last-child {
      padding-bottom: 0px;
    }
    .v-input__control {
      width: 100%;
      .v-input__slot {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        .v-input--selection-controls__input {
          margin-right: 0px;
        }
      }
    }
  }
  .v-select {
    margin-top: 10px;
    padding-top: 0;
    .v-select__selections {
      .v-chip {
        background: #f9f9f9;
        font-size: 12px;
        border-radius: 10px;
      }
    }
  }
  .v-text-field .v-label--active {
    color: #e60000 !important;
  }
  .time-picker-wrapper {
    .v-text-field {
      margin: 0;
      padding: 0px;
      padding-top: 5px;
      flex-direction: row-reverse;
      .v-input__prepend-outer {
        margin-right: 0;
      }
    }
  }
}

.v-menu__content {
  min-width: 100% !important;
  max-width: 100% !important;
  left: 0 !important;
  margin-bottom: -15px;
  transform: translateY(42px);
  position: fixed !important;
  top: 70px !important;
  .v-picker {
    .v-time-picker-title {
      align-items: center;
    }
  }
}

.select-all {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 auto;
}

</style>


